import React, { Component } from "react";
import { connect } from "react-redux";

import css from "./address.module.scss";

import { MdGpsFixed } from "react-icons/md";

class address extends Component {
	render() {
		return (
			<div className={css.addrWrap}>
				<MdGpsFixed size="25px" />
				<span id="centerPosition"></span>
			</div>
		);
	}
}

export default connect(
	(state) => ({}),
	(dispatch) => ({})
)(address);
